import { FetchCarrierAccountPayload } from '~/actions/carrier-accounts.actions';
import api, { armorAPI } from '~/services/api';
import { JSONCarrier } from '~/types/Carrier';
import {
  CarrierServiceLevelsEditPayload,
  JSONCarrierAccount,
  JSONCreateCarrierAccount,
} from '~/types/CarrierAccount';
import { JSONCarrierAccountRegStatus } from '~/types/CarrierAccountRegStatus';

export function getCarrierAccount(id: string) {
  return api.request({
    url: `/carrier_accounts/${id}`,
    method: 'GET',
  });
}

export function getCarrierAccounts(payload?: FetchCarrierAccountPayload) {
  return api.request<{ results: JSONCarrierAccount[] }>({
    url: '/carrier_accounts',
    method: 'GET',
    params: {
      /* results: X, Default solution; otherwise, only 5 results are returned.
      Does not return 999 -> 'MAX_PAGINATE_BY': 200 hardcoded limit on back end */
      results: 999,
      ...payload,
    },
  });
}

export function getCarrierProviders(carriers: string[]) {
  return armorAPI.request<{ results: { carriers: JSONCarrier[] } }>({
    url: '/setting/carriers',
    method: 'GET',
    params: {
      carriers: carriers,
    },
  });
}

export function connectCarrierAccount(carrierAccount: JSONCarrierAccount) {
  return api.request<JSONCarrierAccount>({
    url: '/carrier_accounts',
    method: 'POST',
    data: {
      ...carrierAccount,
    },
  });
}

export function editCarrierAccount(carrierAccount: JSONCarrierAccount, id: string) {
  return api.request<JSONCarrierAccount>({
    url: `/carrier_accounts/${id}`,
    method: 'PUT',
    data: {
      ...carrierAccount,
    },
  });
}

export function editCarrierAccountServiceLevels(
  carrierServiceLevels: CarrierServiceLevelsEditPayload,
  account_object_id: string,
) {
  return api.request({
    url: `/carrier_accounts/${account_object_id}/service_levels`,
    method: 'PATCH',
    data: carrierServiceLevels,
  });
}

export function createCarrierAccount(requestBody: JSONCreateCarrierAccount) {
  return api.request({
    url: '/carrier_accounts/register/new',
    method: 'POST',
    data: {
      ...requestBody,
    },
  });
}

export function fetchCarrierAccountRegStatuses() {
  return armorAPI.request<{ results: JSONCarrierAccountRegStatus[] }>({
    url: '/carrier-accounts/reg-status/',
    method: 'GET',
  });
}
